import { render, staticRenderFns } from "./ContactUsView.vue?vue&type=template&id=f0d1e52c&"
import script from "./ContactUsView.vue?vue&type=script&lang=js&"
export * from "./ContactUsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports